import * as React from "react";
import { Alert, Grid, Typography } from "@mui/material";
import { getAccidentReportPersonRegistrationGuideAPI } from "@/util/api/accidentReportPersons";
import type { RegistrationGuide } from "@/models/accidentReportPersons";
import { AccidentReportPersonsConstants as Constants } from "@/pages/AccidentReportPersons/AccidentReportPersonsConstants";

/**
 * 責任者登録数の案内表示。
 * 事故報告責任者一覧画面・事故報告一覧画面の両方に同一内容を表示する。
 * 一覧の営業所単一選択とは無関係に、ログインユーザーが参照可能な営業所のうち
 * 登録中の責任者が0名または1名の営業所をすべて対象とする。
 */
export const ResponsibleRegistrationPrompt = (): JSX.Element | null => {
  const [guide, setGuide] = React.useState<RegistrationGuide | null>(null);

  React.useEffect(() => {
    const fetch = async () => {
      try {
        const response = await getAccidentReportPersonRegistrationGuideAPI();
        setGuide(response.data);
      } catch (error) {
        // 案内表示は補助的なものなので、取得に失敗しても画面全体はそのまま表示する
        console.error("==Error when fetch registration guide==", error);
      }
    };
    fetch();
  }, []);

  if (!guide?.shouldDisplay || guide.offices.length === 0) {
    return null;
  }

  return (
    // 非表示のときに空の Grid item が余白を残さないよう、レイアウトもこのコンポーネントが持つ
    <Grid item xs={12}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        <Typography variant="body2" sx={{ fontWeight: "bold" }}>
          {Constants.RegistrationPromptTitle}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5 }}>
          {Constants.RegistrationPromptBody}
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          {Constants.RegistrationPromptOfficesLabel}{" "}
          {guide.offices
            .map((office) =>
              Constants.RegistrationPromptOfficeFormat(
                office.officeName ?? "-",
                office.activePersonCount,
              ),
            )
            .join("、")}
        </Typography>
      </Alert>
    </Grid>
  );
};
